import {
  BzitResponse,
  OfferVehicleParams,
  RegisterShowParams,
  SendBookmarkParams,
  SendContactParams,
  SendFormResult,
  SendVehicleParams,
  ServiceResult
} from '../../bzit';
import { SEARCH_URL } from '../../configs/env';
import { fetchJson } from '../../utils/fetch';

export const sendContact = async (
  contactData: SendContactParams
): Promise<ServiceResult<SendFormResult>> => {
  try {
    const result = await fetchJson<BzitResponse<SendFormResult>>(
      `${SEARCH_URL}contactGeneral`,
      {
        method: 'post',
        body: JSON.stringify(contactData)
      }
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

export const sendVehicle = async (
  vehicleData: SendVehicleParams
): Promise<ServiceResult<SendFormResult>> => {
  try {
    const result = await fetchJson<BzitResponse<SendFormResult>>(
      `${SEARCH_URL}contactVehicle`,
      {
        method: 'post',
        body: JSON.stringify(vehicleData)
      }
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

export const sendBookmark = async (
  bookmarkData: SendBookmarkParams
): Promise<ServiceResult<SendFormResult>> => {
  try {
    const result = await fetchJson<BzitResponse<SendFormResult>>(
      `${SEARCH_URL}contactWatchlist`,
      {
        method: 'post',
        body: JSON.stringify(bookmarkData)
      }
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

export const offerVehicle = async (
  vehicleData: OfferVehicleParams
): Promise<ServiceResult<SendFormResult>> => {
  try {
    const result = await fetchJson<BzitResponse<SendFormResult>>(
      `${SEARCH_URL}contactOffer`,
      {
        method: 'post',
        body: JSON.stringify(vehicleData)
      }
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};

export const registerShow = async (
  showData: RegisterShowParams
): Promise<ServiceResult<SendFormResult>> => {
  try {
    const result = await fetchJson<BzitResponse<SendFormResult>>(
      `${SEARCH_URL}contactRegisterEvent`,
      {
        method: 'post',
        body: JSON.stringify(showData)
      }
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};
